import { css } from '@emotion/css';

export const main = css`
  display: block;
  max-width: 100%;
  height: auto;
`;
